__turbopack_context__.v({
  "blue": "styles-module__kKg8_W__blue",
  "btnChildren": "styles-module__kKg8_W__btnChildren",
  "button": "styles-module__kKg8_W__button",
  "disabled": "styles-module__kKg8_W__disabled",
  "ghost": "styles-module__kKg8_W__ghost",
  "loader": "styles-module__kKg8_W__loader",
  "loading": "styles-module__kKg8_W__loading",
});
